import fetch from '@/utils/fetch'
import {
  shop_url
} from '@/global'

// 资产管理-查询用户可提现信息
const mayWithdrawal = (mchId) => {
  return fetch({
    url: `${shop_url}/shop/mp/ccountWithdrawal/${mchId}`,
    method: 'get'
  })
}

// 资产管理-条件查询商户提现列表
const withdrawalList = (data) => {
  let f = {
    status: -1,
    start: '',
    end: '',
    page: 1,
    mchId: '',
    rows: 10
  }
  Object.assign(f, data)
  return fetch({
    url: `${shop_url}/shop/mp/withdrawalList`,
    method: 'post',
    data: f
  })
}

// 资产管理-申请提现
const putWithdrawl = (account, cashSubject, AccountNo, type) => {
  return fetch({
    url: `${shop_url}/shop/mp/ccountWithdrawal`,
    method: 'put',
    data: {
      account: account,
      cashSubject: cashSubject,
      accountNo: AccountNo,
      type: type
    }
  })
}

// 资产管理-查询商户提现进度
const withdrawStatus = (orderId) => {
  return fetch({
    url: `${shop_url}/shop/mp/withdeawalStatus/${orderId}`,
    data: orderId,
    method: 'post'
  })
}

export {
  mayWithdrawal,
  withdrawalList,
  putWithdrawl,
  withdrawStatus
}



// WEBPACK FOOTER //
// ./src/api/withdraw/index.js